<template>
    <q-dialog v-model="showModal" persistent ref="dialog">
        <q-card style="max-width: 500px;" class="full-width">
            <q-card-section>
                <div class="text-h6 row items-center">
                    <q-icon name="mdi-lock" size="sm" class="q-mr-xs" /><span class="gt-xs">License Restricted to OEM Edition</span>
                    <q-space />
                    <q-btn icon="mdi-close" flat round dense v-close-popup @click="dismiss" />
                </div>
            </q-card-section>

            <q-card-section v-for="item in items" :key="item.id" class="row">
                <q-item v-html="item.discountCodeLockedToOemItemWarningMessage" class="text-caption q-pa-none">
                </q-item>
            </q-card-section>

            <q-card-section class="q-pt-none">
                <div class="row q-col-gutter-sm justify-end">
                    <div class="col-xs-12 col-sm-auto">
                        <q-btn label="OK" color="primary" flat class="full-width" v-close-popup @click="dismiss" />
                    </div>
                </div>
            </q-card-section>
        </q-card>
    </q-dialog>
</template>
<script>

    export default {
        name: 'dialog-license-oem-locked',
        props: {
            show: {
                type: Boolean,
                default: false
            },
            items: Array,
        },
        methods: {
            dismiss() {
                this.$store.commit('set_licenseOemLockedItemsViewed', true)
                this.$store.commit('set_showLicenseOemLockedDialog', false)
            },
        },
        computed: {
            showModal: {
                get() {
                    return this.show
                },
                set(value) {
                    this.$store.commit('set_showLicenseOemLockedDialog', value)
                }
            },
        },
    }
</script>
<style>
    .oemLockImage {
        margin-right: 15px;
        align-self: center;
        width: 10rem !important;
        text-align: center;
    }

        .oemLockImage img {
            width: inherit;
            max-width: fit-content;
        }

    .oemName {
        font-weight: bolder;
        text-decoration: underline;
    }
</style>
